import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { websocketProxyUrl } from '../../../../urls'

const headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const websocketProxyInstance = axios.create({
	baseURL: websocketProxyUrl,
	headers,
})

websocketProxyInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

websocketProxyInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default websocketProxyInstance
